module.exports = __webpack_public_path__ + "img/adventure.74e07c39.jpg";